// extracted by mini-css-extract-plugin
export default {"UsersTapleTow":"userstaple_2_UsersTapleTow__gTurY","markRow":"userstaple_2_markRow__kUpNE"};